import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError, ValidationErrors } from "components/actions";
import { RxFormFields } from "components/rx-form";
import { Grid, Typography } from "components/controls/widget";
import PageTitle from "common/web/PageTitle";
import PageHeader from "common/web/PageHeader";
import Loading from "common/components/controls/Loading";
import SoutUtils from "common/utils/SoutUtils";
import Error from "common/components/controls/Error";
import { RouteProps } from "./routes-path";
import { Par, apiGetPar } from "common/api/Evidence/Pary/Pary";
import { apiZadostPost, apiZadostUploadFiles, ZadostForm } from "common/api/Evidence/Pary/BodyZahrSout";
import ZadostFormular from "./ZadostForm";



const defValues = {
    SoutDatum: '12.3.2016',
    SoutNazev: 'nazev',
    SoutMisto: 'misto',
    SoutStat: 'stat',
    SoutVekKtg: 'J1',
    SoutVykTrida: 'C',
    SoutDisciplina: 'L',
    SoutPocetParu: '40',
    ParPartnerIdt: '10506288',
    ParPartnerkaIdt: '10103982',
    ParPocetKol: '2',
    ParUmisteni: '1',
    //DolozeniUrlAdresa: 'http://aaa.cz',
    DolozeniSoubor: {},
    SoutPocKolektivnichClenu: '3',
    ParVeFinale: 'true',
};

const ziskaneBodyNeniMozneUrcit = 'počet bodů není možné určit.';
const ziskaneFinaleNeniMozneUrcit = 'finále není možné určit.';

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    par?: Par;
    ziskaneBody: string;
    ziskaneFinale: string;
}

type ZadostPripsaniBoduZahrSoutProps = RouteComponentProps<RouteProps>;

type PropsType = ZadostPripsaniBoduZahrSoutProps & State & ActionsExecutorPropsType & WithStyles<typeof styles>;

const initialState: State = {
    loading: true,
    hasError: false,
    ziskaneBody: ziskaneBodyNeniMozneUrcit,
    ziskaneFinale: ziskaneFinaleNeniMozneUrcit,
}

class ZadostPripsaniBoduZahrSout extends React.PureComponent<PropsType> {

    loadUdajeParu = () => {
        const { executeAction, updateState } = this.props;
        const { idParu } = this.props.match.params;
        const action = apiGetPar(Number(idParu))
            .onSuccess(d => {
                updateState({ loading: false, par: d });
            })
            .onError(e => {
                const errMessage = e.errorData && e.errorData.notFound ? `Pár ID ${idParu} nebyl nalezen` : e.message;
                updateState({ loading: false, hasError: true, error: errMessage });
            });

        executeAction(action, { loading: true, hasError: false });
    }

    handleSubmitError = (e: ActionError, failure: (errors: ValidationErrors) => void) => {
        if (e.errorData && e.errorData.validationError) {
            failure(e.errorData.validationErrors);
        } else {
            failure({ '_error': e.message });
        }
    }

    onSubmit = (data: { [key: string]: any }, success: () => void, failure: (errors: { [key: string]: string }) => void) => {
        console.log("onSubmit: ", data);

        const formData: ZadostForm = {
            SoutDatum: data['SoutDatum'],
            SoutNazev: data['SoutNazev'],
            SoutMisto: data['SoutMisto'],
            SoutStat: data['SoutStat'],
            SoutVekKtg: data['SoutVekKtg'],
            SoutVykTrida: data['SoutVykTrida'],
            SoutDisciplina: data['SoutDisciplina'],
            SoutPocetParu: data['SoutPocetParu'],
            SoutPocKolektivnichClenu: data['SoutPocKolektivnichClenu'],
            ParPartnerIdt: this.props.par.Partner.Idt,
            ParPartnerkaIdt: this.props.par.Partnerka.Idt,
            ParPocetKol: data['ParPocetKol'],
            ParUmisteni: data['ParUmisteni'],
            ParVeFinale: data['ParVeFinale'],
            DolozeniUrlAdresa: data['DolozeniUrlAdresa'],
            CheckValidity: true
        }

        if (data.DolozeniSoubor && data.DolozeniSoubor.length > 0) {
            console.log("onSubmit222: ", data.DolozeniSoubor);

            var fd = new FormData();
            fd.append('DolozeniSoubor', data.DolozeniSoubor[0]);

            const action = apiZadostPost()
                .onSuccess(() => {
                    const uploadAction = apiZadostUploadFiles()
                        .onSuccess(d => {
                            formData.DolozeniSoubor = d;
                            formData.CheckValidity = false;
                            const postAction = apiZadostPost()
                                .onSuccess(() => success())
                                .onError(e => this.handleSubmitError(e, failure));

                            this.props.executeAction(postAction, {}, formData);
                        })
                        .onError(e => this.handleSubmitError(e, failure));

                    this.props.executeAction(uploadAction, {}, fd);
                })
                .onError(e => this.handleSubmitError(e, failure));

            this.props.executeAction(action, {}, formData);
        } else {
            formData.CheckValidity = false;
            const action = apiZadostPost()
                .onSuccess(() => success())
                .onError(e => this.handleSubmitError(e, failure));

            this.props.executeAction(action, {}, formData);
        }



        /*        if (data['soutDatum'] !== "1.1.1010")
                    success();
                else
                    failure({ '_error': "Global error", soutDatum: 'chyba data' });
                    */
    }

    onValidated = (fields: RxFormFields) => {
        console.log("ON VALIDATED: ", fields.DolozeniSoubor.value);
        const newState = {
            ziskaneBody: ziskaneBodyNeniMozneUrcit,
            ziskaneFinale: ziskaneFinaleNeniMozneUrcit,
        };

        if (fields.SoutPocetParu.valid && fields.ParPocetKol.valid && fields.ParUmisteni.valid && fields.SoutPocKolektivnichClenu.valid && fields.ParVeFinale.valid) {
            console.log("ON VALIDATED 3: ");
            const umisteni = fields.ParUmisteni.value.toString().split('-');
            let umisteniOd = 0;
            let umisteniDo = 0;
            if (umisteni.length == 1) {
                umisteniOd = Number(umisteni[0]);
                umisteniDo = Number(umisteni[0]);
            }
            else if (umisteni.length == 2) {
                umisteniOd = Number(umisteni[0]);
                umisteniDo = Number(umisteni[1]);
            }
            const zahrBody = SoutUtils.vypocetBoduZahranicniSouteze(Number(fields.SoutPocetParu.value), Number(fields.ParPocetKol.value), umisteniOd, umisteniDo, Number(fields.SoutPocKolektivnichClenu.value), Boolean(fields.ParVeFinale.value === 'true'));
            newState.ziskaneBody = zahrBody.body !== undefined ? zahrBody.body.toString() : ziskaneBodyNeniMozneUrcit;
            newState.ziskaneFinale = zahrBody.finale === true ? "Ano" : zahrBody.finale === false ? "Ne" : ziskaneFinaleNeniMozneUrcit;
        }
        console.log("ON VALIDATED 2: ", newState);
        this.props.updateState(newState);
    }

    componentWillMount() {
        this.loadUdajeParu();
    }

    render() {
        const { ziskaneBody, ziskaneFinale, classes, loading, hasError, error, par } = this.props;

        console.log("ON VALRENDER: ", this.state);

        return <div>
            <PageTitle title="Žádost páru o připsání bodů ze zahraniční soutěže" />
            <PageHeader>
                {loading
                    ? <Loading loading={loading} color="primary" />
                    : hasError
                        ? <Error>{error}</Error>
                        : <Grid>
                            <Typography variant="h6">{`${par.Partner.Prijmeni} ${par.Partner.Jmeno} (${par.Partner.Idt})`}</Typography>
                            <Typography variant="h6">{`${par.Partnerka.Prijmeni} ${par.Partnerka.Jmeno} (${par.Partnerka.Idt})`}</Typography>
                        </Grid>
                }
            </PageHeader>

            {loading || hasError || <Grid container direction="row" justify="flex-end" wrap="nowrap">
                <Grid item className={classes.grow}>
                    <ZadostFormular defaultValues={defValues} onSubmit={this.onSubmit} formName="ZadostForm" onValidated={this.onValidated} ziskaneBody={ziskaneBody} ziskaneFinale={ziskaneFinale} />
                </Grid>
            </Grid>
            }

        </div >
    }
}


export const styles = (theme: Theme) => createStyles({
    grow: {
        flexGrow: 1,
    },
});

export default withStyles(styles)(withRouter(withActionsExecutor<ZadostPripsaniBoduZahrSoutProps, State>(initialState, ZadostPripsaniBoduZahrSout))); 
